<template>
  <span :class="onlineStatus" @click="getStatus"><i class="fa" v-bind:class="{ 'rotating': loading, 'fa-refresh': loading, 'fa-circle': !loading }"></i> <small v-if="displayRtt">{{ status.rtt/1000 }} ms</small></span>
</template>
<script>

export default {
  name: 'DeviceStatus',
  props: [ 'deviceId', 'showRtt' ],
  computed: {
    onlineStatus: function () {
      if (this) {
        const extensions = this.status.extensions
        if (this.loading) {
          return 'loading'
        } else if (extensions.connected === 0) {
          return 'offline'
        } else if (extensions.configured === extensions.connected) {
          return 'online'
        } else {
          return 'partial'
        }
      }
    },
    displayRtt: function () {
      if (this) {
        return (typeof this.showRtt == 'undefined' || this.showRtt) && !this.loading && this.status.rtt
      }
      return false
    }
  },
  data () {
    return {
      loading: true,
      status: {
        online: false,
        extensions: {
          configured: 0,
          connected: 0
        },
        rtt: null
      }
    }
  },
  methods: {
    getStatus () {
      this.loading = true
      const id = this.deviceId
      this.$axios.get(`/v1/devices/${id}/status`).then(({ data }) => {
        Object.assign(this.status, data)
        this.loading = false
        this.$emit('update', data)
      })
    }
  },
  created () {
    this.getStatus()
  }
}
</script>

<style lang="scss" scoped>
span {
  cursor: pointer;
  white-space: nowrap;

  &.online {
    color: #4dbd74;
  }
  &.partial {
    color: #ffc107;
  }
  &.offline {
    color: #f86c6b;
  }

  small {
    color: #23282c;
    margin-left: 5px;
  }

}
@-webkit-keyframes rotating /* Safari and Chrome */ {
  from {
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes rotating {
  from {
    -ms-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -ms-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
.rotating {
  -webkit-animation: rotating 2s linear infinite;
  -moz-animation: rotating 2s linear infinite;
  -ms-animation: rotating 2s linear infinite;
  -o-animation: rotating 2s linear infinite;
  animation: rotating 2s linear infinite;
}

</style>
